export default __webpack_public_path__ + "static/media/whatsapp.54b029af.svg";